/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Collectionoffers_Title1Inputs */

const id_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Koleksi`)
};

const ms_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Koleksi`)
};

const da_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlingstilbud`)
};

const de_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammlungsangebote`)
};

const en_us2_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collection Offers`)
};

const es_es2_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de colección`)
};

const es_mx2_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de colección`)
};

const fil_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Collection Offer`)
};

const fr_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres de collection`)
};

const it_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte collezione`)
};

const hu_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyűjtemény ajánlatok`)
};

const nl_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collectieaanbiedingen`)
};

const no_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlingstilbud`)
};

const pl_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty kolekcji`)
};

const pt_br2_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collection Offers`)
};

const pt_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas de coleção`)
};

const ro_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte de colecție`)
};

const fi_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokoelmien tarjoukset`)
};

const sv_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlingserbjudanden`)
};

const vi_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi bộ sưu tập`)
};

const tr_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksiyon Teklifleri`)
};

const cs_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky kolekce`)
};

const bg_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекционни оферти`)
};

const ru_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложения подборки`)
};

const uk_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колекційні пропозиції`)
};

const ar_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عروض المجموعة`)
};

const hi_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कलेक्शन ऑफ़र`)
};

const th_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอคอลเล็กชัน`)
};

const ja_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクションオファー`)
};

const zh_cn2_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collection Offers`)
};

const zh_hant1_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collection Offers`)
};

const ko_components_collectionoffers_title1 = /** @type {(inputs: Components_Collectionoffers_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collection Offers`)
};

/**
* | output |
* | --- |
* | "Collection Offers" |
*
* @param {Components_Collectionoffers_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_collectionoffers_title1 = /** @type {((inputs?: Components_Collectionoffers_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Collectionoffers_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_collectionoffers_title1(inputs)
	if (locale === "ms") return ms_components_collectionoffers_title1(inputs)
	if (locale === "da") return da_components_collectionoffers_title1(inputs)
	if (locale === "de") return de_components_collectionoffers_title1(inputs)
	if (locale === "en-US") return en_us2_components_collectionoffers_title1(inputs)
	if (locale === "es-ES") return es_es2_components_collectionoffers_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_collectionoffers_title1(inputs)
	if (locale === "fil") return fil_components_collectionoffers_title1(inputs)
	if (locale === "fr") return fr_components_collectionoffers_title1(inputs)
	if (locale === "it") return it_components_collectionoffers_title1(inputs)
	if (locale === "hu") return hu_components_collectionoffers_title1(inputs)
	if (locale === "nl") return nl_components_collectionoffers_title1(inputs)
	if (locale === "no") return no_components_collectionoffers_title1(inputs)
	if (locale === "pl") return pl_components_collectionoffers_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_collectionoffers_title1(inputs)
	if (locale === "pt") return pt_components_collectionoffers_title1(inputs)
	if (locale === "ro") return ro_components_collectionoffers_title1(inputs)
	if (locale === "fi") return fi_components_collectionoffers_title1(inputs)
	if (locale === "sv") return sv_components_collectionoffers_title1(inputs)
	if (locale === "vi") return vi_components_collectionoffers_title1(inputs)
	if (locale === "tr") return tr_components_collectionoffers_title1(inputs)
	if (locale === "cs") return cs_components_collectionoffers_title1(inputs)
	if (locale === "bg") return bg_components_collectionoffers_title1(inputs)
	if (locale === "ru") return ru_components_collectionoffers_title1(inputs)
	if (locale === "uk") return uk_components_collectionoffers_title1(inputs)
	if (locale === "ar") return ar_components_collectionoffers_title1(inputs)
	if (locale === "hi") return hi_components_collectionoffers_title1(inputs)
	if (locale === "th") return th_components_collectionoffers_title1(inputs)
	if (locale === "ja") return ja_components_collectionoffers_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_collectionoffers_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_collectionoffers_title1(inputs)
	return ko_components_collectionoffers_title1(inputs)
});
export { components_collectionoffers_title1 as "components.collectionOffers.title" }